// Module Vuex pour la gestion des utilisateurs
// Traduit depuis apps/pwa/src/Reducer/User.js
import dexieService from '../../services/dexieService'

const state = {
  currentUser: null,
  loading: false,
  error: null
}

const mutations = {
  SET_CURRENT_USER(state, user) {
    state.currentUser = user
  },
  
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  
  SET_ERROR(state, error) {
    state.error = error
  },
  
  CLEAR_USER(state) {
    state.currentUser = null
    state.error = null
  }
}

const actions = {
  setCurrentUser({ commit }, user) {
    commit('SET_CURRENT_USER', user)
  },
  
  syncWithLoginModule({ commit, rootState }) {
    // Synchroniser avec les données du module login
    const loginUser = rootState.login.user
    if (loginUser) {
      commit('SET_CURRENT_USER', loginUser)
    }
  },
  
  async fetchCurrentUser({ commit }) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    
    try {
      const token = await dexieService.getAuthToken()
      if (!token) {
        throw new Error('No auth token')
      }
      
      const response = await fetch('/api/user/me', {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
      
      if (response.ok) {
        const user = await response.json()
        commit('SET_CURRENT_USER', user)
      } else {
        throw new Error('Failed to fetch user')
      }
    } catch (error) {
      commit('SET_ERROR', error.message)
      commit('CLEAR_USER')
    } finally {
      commit('SET_LOADING', false)
    }
  },
  
  clearUser({ commit }) {
    commit('CLEAR_USER')
  }
}

const getters = {
  currentUser: state => state.currentUser,
  isLoading: state => state.loading,
  error: state => state.error,
  userTeam: state => state.currentUser ? state.currentUser.team : null
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
